import React from 'react';
import { useEffect, useState, useCallback } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import MobileMenu from './MobileMenu';
// import MobileMenu from './MobileMenu';

export default function Header() {
  const [isSticky, setIsSticky] = useState(false);
  const [dropdownOpen1, setDropdownOpen1] = useState(false);
  const [dropdownOpen2, setDropdownOpen2] = useState(false);
  const [dropdownOpen3, setDropdownOpen3] = useState(false);
  const [dropdownOpen4, setDropdownOpen4] = useState(false);
  const [dropdownOpen5, setDropdownOpen5] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const handleToggleMenu = useCallback(() => setIsOpen((prev) => !prev), []);
 

  const handleScroll = useCallback(() => {
    const heightFromTop = window.scrollY;
    setIsSticky(heightFromTop > 0);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  return (
    <>
      <header className={`header-area ${isSticky ? 'stick' : ''}`}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-3 col-6 col-md-6">
              <div className="logo">
                <Link to={"/"}><img src="/logo.webp" alt="Logo" /></Link>
              </div>
            </div>

            <div className="col-lg-6 col-5 col-md-6 mobile-tab-hide">
              <div className="menuright">
                <ul className="main-menu">

                  {/* Company Dropdown */}
                  <li className={`nav-item dropdown has-dropdown ${dropdownOpen1 ? "show" : ""}`} onMouseEnter={() => setDropdownOpen1(true)} onMouseLeave={() => setDropdownOpen1(false)}>
                    <Link>Company <i className="fa-solid fa-angle-down"></i></Link>
                    <ul className={`dropdown-menu ${dropdownOpen1 ? "show" : ""}`}>
                      <li><Link to="/about-us">About</Link></li>
                      <li><Link to="/location">Our Locations</Link></li>
                      <li><Link to="/team">Our Team</Link></li>
                      <li><Link to="/sustainability">sustainability</Link></li>
                      <li><Link to="/contact">Contact</Link></li>
                    </ul>
                  </li>

                  {/* Technologies Dropdown */}
                  <li className={`nav-item dropdown has-dropdown ${dropdownOpen2 ? "show" : ""}`} onMouseEnter={() => setDropdownOpen2(true)} onMouseLeave={() => setDropdownOpen2(false)}>
                    <Link>Technologies <i className="fa-solid fa-angle-down"></i></Link>
                    <ul className={`dropdown-menu dropdown-menu-big ${dropdownOpen2 ? "show" : ""}`}>
                      <li className='menu-list-title'>Technologies</li>
                      <li><Link to="/iot-enabled">IOT enabled</Link></li>
                      <li><Link to="/artificial-intelligence">artificial intelligence</Link></li>
                      <li><Link to="/infrastructure">infrastructure</Link></li>
                      <li><Link to="/data-integration-visibility">data integration visibility</Link></li>
                      <li><Link to="/data-analytics">data analytics</Link></li>
                      <li><Link to="/cloud-computing">cloud computing</Link></li>
                    </ul>
                  </li>

                  {/* Industries Dropdown */}
                  <li className={`nav-item dropdown has-dropdown ${dropdownOpen3 ? "show" : ""}`} onMouseEnter={() => setDropdownOpen3(true)} onMouseLeave={() => setDropdownOpen3(false)}>
                    <Link>Industries <i className="fa-solid fa-angle-down"></i></Link>
                    
                    <ul className={`dropdown-menu dropdown-menu-big ${dropdownOpen3 ? "show" : ""}`}>
                      <li className='menu-list-title'>Industries</li>
                      <li><Link to="/financial-institutions">Finance</Link></li>
                      <li><Link to="/media-entertainment-records-management">media & entertainment</Link></li>
                      <li><Link to="/insurance-document-management-services">insurance</Link></li>
                      <li><Link to="/government-records-management-services">government</Link></li>
                      <li><Link to="/cpg-retail-records-management">CPG & Retail</Link></li>
                      <li><Link to="/healthcare">Healthcare</Link></li>
                      <li><Link to="/education-training">Education Training</Link></li>
                      <li><Link to="/other-industries-we-serve">other industries</Link></li>

                      <li className='menu-list-title'>Use By Case</li>
                      <li><Link to="/hr-document-management-services">Human Resources</Link></li>
                      <li><Link to="/small-business-solution">Small business Solution</Link></li>
                      <li><Link to="/finance-document-management-services">Finance & Accounting</Link></li>
                      <li><Link to="/sales-document-management-solutions">sales</Link></li>
                      <li><Link to="/enterprise-document-management-solutions">Large enterprises</Link></li>
                      <li><Link to="/mobile-workforce-document-solutions">mobile workforce</Link></li>
                    </ul>
                  </li>

                  {/* Services Dropdown */}
                  <li className={`nav-item dropdown has-dropdown ${dropdownOpen4 ? "show" : ""}`} onMouseEnter={() => setDropdownOpen4(true)} onMouseLeave={() => setDropdownOpen4(false)}>
                    <Link>Services <i className="fa-solid fa-angle-down"></i></Link>
                    <ul className={`dropdown-menu ${dropdownOpen4 ? "show" : ""}`}>
                      <li><Link to="/physical-records-management-services">Physical Archive</Link></li>
                      <li><Link to="/ai-document-data-extraction">Cognitive AI</Link></li>
                      <li><Link to="/document-digitization">Digital Archive</Link></li>
                      <li><Link to="/data-privacy-governance-compliance-platform">Compliance OS</Link></li>
                    </ul>
                  </li>

                  {/* Insights Dropdown */}
                  <li className={`nav-item dropdown has-dropdown ${dropdownOpen5 ? "show" : ""}`} onMouseEnter={() => setDropdownOpen5(true)} onMouseLeave={() => setDropdownOpen5(false)}>
                    <Link>Insights <i className="fa-solid fa-angle-down"></i></Link>
                    <ul className={`dropdown-menu ${dropdownOpen5 ? "show" : ""}`}>
                      <li><Link to="/blog">Blogs</Link></li>
                      {/* <li><Link to="/press-release">Press Releases</Link></li>
                      <li><Link to="/case-study">case studies</Link></li> */}
                    </ul>
                  </li>

                </ul>
              </div>
            </div>

            <div className="col-lg-3 col-6 col-md-3 mobile-tab-hide">
                <div className="menucontact">
                  <ul className="main-menu">   
                    <li><Link to="tel:+91-9580 374 374"><span><img src="/assets/images/header-phone.webp" alt="Phone" />  +91-9580 374 374</span></Link></li>  
                  </ul>
                </div>                
            </div>

            <div className="col-6">
              <div className="menu-toogle" onClick={handleToggleMenu}>
                  <div className="menu-line icon-top"></div>
                  <div className="menu-line icon-center"></div>
                  <div className="menu-line icon-bottom"></div>
                </div>
            </div>
          </div>
        </div>
      </header>

      <MobileMenu isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  )
}